import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: number; output: number; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: Date; output: Date; }
  DateTime: { input: Date; output: Date; }
  DateTimeOffset: { input: any; output: any; }
  Decimal: { input: number; output: number; }
  Milliseconds: { input: number; output: number; }
  Seconds: { input: number; output: number; }
};

export type AddOrUpdateTemplateUsageInputType = {
  projectId: Scalars['String']['input'];
  templateId: Scalars['Int']['input'];
  usage: EEmailUsage;
};

export type AddOrUpdateTemplateUsageSmsInputType = {
  projectId: Scalars['String']['input'];
  templateId: Scalars['Int']['input'];
  usage: ESmsUsage;
};

/** A connection from an object to a list of objects of type `Announce`. */
export type AnnounceConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<AnnounceEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<AnnounceGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Announce`. */
export type AnnounceEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AnnounceGraphType>;
};

export type AnnounceGraphType = {
  /** Content */
  content: Scalars['String']['output'];
  /** End date */
  end?: Maybe<Scalars['DateTime']['output']>;
  /** Id */
  id: Scalars['Int']['output'];
  /** Is active */
  isActive: Scalars['Boolean']['output'];
  /** Location */
  location: Scalars['String']['output'];
  /** Start date */
  start?: Maybe<Scalars['DateTime']['output']>;
  /** Title */
  title: Scalars['String']['output'];
};

export type AnnounceMutation = {
  /** Add announce */
  add?: Maybe<AnnounceGraphType>;
  /** Delete an announce */
  delete?: Maybe<Scalars['Boolean']['output']>;
  /** Update announce */
  update?: Maybe<AnnounceGraphType>;
  /** Viewed */
  viewed?: Maybe<Scalars['Boolean']['output']>;
};


export type AnnounceMutationAddArgs = {
  content: Scalars['String']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  isActive: Scalars['Boolean']['input'];
  location: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};


export type AnnounceMutationDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type AnnounceMutationUpdateArgs = {
  content: Scalars['String']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  location: Scalars['String']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};


export type AnnounceMutationViewedArgs = {
  id: Scalars['Int']['input'];
};

export type AnnounceQuery = {
  /** Get by location */
  byLocation?: Maybe<AnnounceGraphType>;
  byProject?: Maybe<AnnounceConnection>;
  get?: Maybe<AnnounceGraphType>;
};


export type AnnounceQueryByLocationArgs = {
  location: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type AnnounceQueryByProjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['String']['input'];
};


export type AnnounceQueryGetArgs = {
  id: Scalars['Int']['input'];
};

export type AssetGraphType = {
  contentType?: Maybe<Scalars['String']['output']>;
  /** Presigned Url */
  presignedUrl?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type AssetGraphTypePresignedUrlArgs = {
  timeOut?: InputMaybe<Scalars['Int']['input']>;
};

export type AttachmentInputType = {
  bucket: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type CreateUpdateProjectSettingsInputType = {
  projectId: Scalars['String']['input'];
  settings: Array<InputMaybe<ProjectSettingInputType>>;
};

export type DictionaryGraphType = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DictionaryTemplateLayoutKeyGraphType = {
  key?: Maybe<ETemplateLayoutKey>;
  value: Scalars['String']['output'];
};

export type DictionaryTemplateLayoutKeyInputType = {
  key?: InputMaybe<ETemplateLayoutKey>;
  value: Scalars['String']['input'];
};

export enum EEmailUsage {
  AccessReminder = 'ACCESS_REMINDER',
  ActivateAccount = 'ACTIVATE_ACCOUNT',
  CommentCommented = 'COMMENT_COMMENTED',
  CommentRelated = 'COMMENT_RELATED',
  CommentReported = 'COMMENT_REPORTED',
  CommunitySuggested = 'COMMUNITY_SUGGESTED',
  Contact = 'CONTACT',
  ContactFormValidation = 'CONTACT_FORM_VALIDATION',
  Error = 'ERROR',
  ForgotPassword = 'FORGOT_PASSWORD',
  GroupCreationAccepted = 'GROUP_CREATION_ACCEPTED',
  GroupCreationDeclined = 'GROUP_CREATION_DECLINED',
  GroupCreationRequest = 'GROUP_CREATION_REQUEST',
  GroupCreationTransferred = 'GROUP_CREATION_TRANSFERRED',
  GroupInvitation = 'GROUP_INVITATION',
  InvitationAccepted = 'INVITATION_ACCEPTED',
  Invoice = 'INVOICE',
  NewCommentAdded = 'NEW_COMMENT_ADDED',
  NewPostAdded = 'NEW_POST_ADDED',
  OrganisationInvitation = 'ORGANISATION_INVITATION',
  PartnerInvitation = 'PARTNER_INVITATION',
  PaymentFailed = 'PAYMENT_FAILED',
  PostCommented = 'POST_COMMENTED',
  PostEmbargoed = 'POST_EMBARGOED',
  PostRelated = 'POST_RELATED',
  PostReported = 'POST_REPORTED',
  ProjectInvitation = 'PROJECT_INVITATION',
  ReportRequested = 'REPORT_REQUESTED',
  SensitiveContent = 'SENSITIVE_CONTENT',
  SuccessfulRegistration = 'SUCCESSFUL_REGISTRATION',
  TierApproaching = 'TIER_APPROACHING',
  UpdateEmail = 'UPDATE_EMAIL',
  UserReported = 'USER_REPORTED'
}

export enum EInternalNotificationUsage {
  ActivityAssigned = 'ACTIVITY_ASSIGNED',
  CalenderEvent = 'CALENDER_EVENT',
  CommentedComment = 'COMMENTED_COMMENT',
  CommentedPost = 'COMMENTED_POST',
  CommentReported = 'COMMENT_REPORTED',
  CommunityConnectedRequested = 'COMMUNITY_CONNECTED_REQUESTED',
  CommunitySuggested = 'COMMUNITY_SUGGESTED',
  ConnectionInactive = 'CONNECTION_INACTIVE',
  EmbargoedContent = 'EMBARGOED_CONTENT',
  LikedComment = 'LIKED_COMMENT',
  MessageReceive = 'MESSAGE_RECEIVE',
  ModuleCompleted = 'MODULE_COMPLETED',
  ModuleLicensed = 'MODULE_LICENSED',
  PostReported = 'POST_REPORTED',
  ReceivedConnectionAccept = 'RECEIVED_CONNECTION_ACCEPT',
  ReceivedConnectionRequest = 'RECEIVED_CONNECTION_REQUEST',
  RelatePost = 'RELATE_POST',
  Reminder = 'REMINDER',
  ResetCommitmentClock = 'RESET_COMMITMENT_CLOCK',
  SensitiveContent = 'SENSITIVE_CONTENT',
  SharedRedFeeling = 'SHARED_RED_FEELING',
  Survey = 'SURVEY',
  UnitModeAssigned = 'UNIT_MODE_ASSIGNED',
  UserFlowStepTrackMarked = 'USER_FLOW_STEP_TRACK_MARKED',
  UserReported = 'USER_REPORTED',
  WallPost = 'WALL_POST'
}

export enum EMessageType {
  Application = 'APPLICATION',
  Marketing = 'MARKETING',
  Newsletter = 'NEWSLETTER',
  None = 'NONE',
  Reminder = 'REMINDER'
}

export enum ENotificationStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export enum ENotificationType {
  Email = 'EMAIL',
  InternalNotification = 'INTERNAL_NOTIFICATION',
  PushNotification = 'PUSH_NOTIFICATION',
  Sms = 'SMS',
  WebPush = 'WEB_PUSH'
}

export enum EProjectFeature {
  ContactFormValidationEmail = 'CONTACT_FORM_VALIDATION_EMAIL',
  DeIdentifyReports = 'DE_IDENTIFY_REPORTS',
  Email = 'EMAIL',
  PushNotification = 'PUSH_NOTIFICATION',
  Sms = 'SMS'
}

export enum EProjectSetting {
  /** Define if the project has announcement */
  HasAnnouncement = 'HAS_ANNOUNCEMENT'
}

export enum ESmsUsage {
  ActivateAccount = 'ACTIVATE_ACCOUNT',
  ForgotPassword = 'FORGOT_PASSWORD',
  UpdatePhoneNumber = 'UPDATE_PHONE_NUMBER'
}

export enum ETemplateLayoutKey {
  Align = 'ALIGN',
  BackgroundColour = 'BACKGROUND_COLOUR',
  BorderRadius = 'BORDER_RADIUS',
  Content = 'CONTENT',
  FacebookLink = 'FACEBOOK_LINK',
  HasSocials = 'HAS_SOCIALS',
  InstagramLink = 'INSTAGRAM_LINK',
  IsFacebookLinkActive = 'IS_FACEBOOK_LINK_ACTIVE',
  IsInstagramLinkActive = 'IS_INSTAGRAM_LINK_ACTIVE',
  IsLinkedinLinkActive = 'IS_LINKEDIN_LINK_ACTIVE',
  LinkedinLink = 'LINKEDIN_LINK',
  Logo = 'LOGO',
  Padding = 'PADDING',
  SocialIconStyle = 'SOCIAL_ICON_STYLE',
  SocialMediaText = 'SOCIAL_MEDIA_TEXT',
  TextColour = 'TEXT_COLOUR'
}

export enum ETemplateType {
  Email = 'EMAIL',
  InternalNotification = 'INTERNAL_NOTIFICATION',
  None = 'NONE',
  PushNotification = 'PUSH_NOTIFICATION',
  Sms = 'SMS',
  WebPushNotification = 'WEB_PUSH_NOTIFICATION'
}

export enum EUserNotificationPreference {
  Email = 'EMAIL',
  None = 'NONE',
  PushNotification = 'PUSH_NOTIFICATION',
  Sms = 'SMS'
}

export type ErrorMessageGraphType = {
  /** Id */
  id?: Maybe<Scalars['Int']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
};

export enum FileType {
  Csv = 'CSV',
  Excel = 'EXCEL'
}

export type InputNotificationGroup = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notifications: Array<InputMaybe<NotificationInputType>>;
  projectId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['Int']['input']>;
};

export type InternalNotificationEventMutation = {
  /** Add a clicked event */
  addClickedEvent?: Maybe<Scalars['Boolean']['output']>;
  /** Add seen event for a defined notification */
  addSeenEvent?: Maybe<Scalars['Boolean']['output']>;
  /** Mark seen all unseen notification */
  markAllSeen?: Maybe<Scalars['Boolean']['output']>;
};


export type InternalNotificationEventMutationAddClickedEventArgs = {
  ipAddress: Scalars['String']['input'];
  notificationId: Scalars['Int']['input'];
  userAgent: Scalars['String']['input'];
};


export type InternalNotificationEventMutationAddSeenEventArgs = {
  ipAddress: Scalars['String']['input'];
  notificationGuid: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
};


export type InternalNotificationEventMutationMarkAllSeenArgs = {
  ipAddress: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
};

export type Mutations = {
  /** Contains all the mutations about the Events for internal notification */
  announce?: Maybe<AnnounceMutation>;
  /** Contains all the mutations about the Events for internal notification */
  internalNotificationEvent?: Maybe<InternalNotificationEventMutation>;
  /** Contains all the mutations about the Notifications */
  notification?: Maybe<Notification>;
  placeholder?: Maybe<PlaceholderMutation>;
  /** Contains all the mutations about the Projects */
  project?: Maybe<Project>;
  projectSettings?: Maybe<ProjectSettingsMutation>;
  templateLayout?: Maybe<TemplateLayoutMutation>;
  /** Contains all the mutations about the Templates */
  templates?: Maybe<TemplateMutation>;
  /** Contains all the mutations about the Users */
  user?: Maybe<UserMutation>;
};

export type Notification = {
  addOrUpdatePendingNotification?: Maybe<NotificationGraphType>;
  queueNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Resend notifications */
  resendNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** Send contact form */
  sendContactForm?: Maybe<Scalars['Boolean']['output']>;
  /** Send internal notification to the connected user */
  sendInternalNotificationToCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  /** Allow the connected user to send internal notifications */
  sendInternalNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** Send an email to the connected user */
  sendMailToCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  /** Allow the connected user to send emails */
  sendMails?: Maybe<NotificationGroupGraphType>;
  /** Allow the connected user to send notifications */
  sendNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** Send push notification to project users */
  sendPushNotifications?: Maybe<Scalars['Boolean']['output']>;
};


export type NotificationAddOrUpdatePendingNotificationArgs = {
  date: Scalars['DateTime']['input'];
  notificationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  templateId: Scalars['Int']['input'];
};


export type NotificationQueueNotificationArgs = {
  date: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  placeholders?: InputMaybe<Array<InputMaybe<PlaceholdersInputType>>>;
  projectId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  templateId: Scalars['Int']['input'];
};


export type NotificationResendNotificationsArgs = {
  notificationIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type NotificationSendContactFormArgs = {
  confirmationEmailPlaceholders?: InputMaybe<Array<InputMaybe<PlaceholdersInputType>>>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeholders?: InputMaybe<Array<InputMaybe<PlaceholdersInputType>>>;
  projectId: Scalars['String']['input'];
  sender: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['Int']['input']>;
};


export type NotificationSendInternalNotificationToCurrentUserArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  projectId: Scalars['String']['input'];
  templateId: Scalars['Int']['input'];
};


export type NotificationSendInternalNotificationsArgs = {
  notificationGroup: InputNotificationGroup;
};


export type NotificationSendMailToCurrentUserArgs = {
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInputType>>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  notificationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  sender?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  templateId: Scalars['Int']['input'];
};


export type NotificationSendMailsArgs = {
  notificationGroup: InputNotificationGroup;
  sender?: InputMaybe<Scalars['String']['input']>;
};


export type NotificationSendNotificationsArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  notificationGroup: InputNotificationGroup;
  notificationType: ENotificationType;
};


export type NotificationSendPushNotificationsArgs = {
  content: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  topic: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection from an object to a list of objects of type `Notification`. */
export type NotificationConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<NotificationGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Notification`. */
export type NotificationEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NotificationGraphType>;
};

export type NotificationGraphType = {
  content?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorMessageGraphType>>>;
  guid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  notificationGroup?: Maybe<NotificationGroupGraphType>;
  placeholders?: Maybe<Array<Maybe<Placeholder>>>;
  receiver: Scalars['String']['output'];
  remoteId?: Maybe<Scalars['String']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
  sendOn?: Maybe<Scalars['DateTime']['output']>;
  sendingDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ENotificationStatus>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserGraphType>;
  userId?: Maybe<Scalars['Int']['output']>;
};

/** A connection from an object to a list of objects of type `NotificationGroup`. */
export type NotificationGroupConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<NotificationGroupEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<NotificationGroupGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `NotificationGroup`. */
export type NotificationGroupEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NotificationGroupGraphType>;
};

export type NotificationGroupGraphType = {
  content?: Maybe<Scalars['String']['output']>;
  firstNotificationSendingDate?: Maybe<Scalars['DateTime']['output']>;
  hasBeenSent?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  internalUsage?: Maybe<Array<Maybe<EInternalNotificationUsage>>>;
  notifications?: Maybe<Array<Maybe<NotificationGraphType>>>;
  smsUsage?: Maybe<Array<Maybe<ESmsUsage>>>;
  subject: Scalars['String']['output'];
  template?: Maybe<TemplateGraphType>;
  templateId?: Maybe<Scalars['Int']['output']>;
  usage?: Maybe<Array<Maybe<EEmailUsage>>>;
};


export type NotificationGroupGraphTypeNotificationsArgs = {
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ENotificationStatus>;
};

export type NotificationInputType = {
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInputType>>>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  placeholders?: InputMaybe<Array<InputMaybe<PlaceholdersInputType>>>;
  receiver?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationQueries = {
  /** Search the notifications based on the connected user */
  get?: Maybe<NotificationGraphType>;
  getForConnectedUser?: Maybe<NotificationConnection>;
  getNotificationGroup?: Maybe<NotificationGroupGraphType>;
  /** Check if the user has a pending notification with the defined parameters */
  getPendingNotification?: Maybe<NotificationGraphType>;
  notificationGroups?: Maybe<NotificationGroupConnection>;
  /** Search the notifications */
  notifications?: Maybe<Array<Maybe<NotificationGraphType>>>;
  /** Get the notifications for the connected user */
  notificationsForConnectedUser?: Maybe<Array<Maybe<NotificationGraphType>>>;
};


export type NotificationQueriesGetArgs = {
  notificationId: Scalars['String']['input'];
};


export type NotificationQueriesGetForConnectedUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isSeen?: InputMaybe<Scalars['Boolean']['input']>;
  type: ENotificationType;
};


export type NotificationQueriesGetNotificationGroupArgs = {
  id: Scalars['Int']['input'];
};


export type NotificationQueriesGetPendingNotificationArgs = {
  receiver: Scalars['String']['input'];
  templateId: Scalars['Int']['input'];
};


export type NotificationQueriesNotificationGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['String']['input'];
};


export type NotificationQueriesNotificationsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  notificationGroupId?: InputMaybe<Scalars['Int']['input']>;
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['String']['input'];
  receivers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ENotificationStatus>;
  type?: InputMaybe<ENotificationType>;
};


export type NotificationQueriesNotificationsForConnectedUserArgs = {
  isSeen?: InputMaybe<Scalars['Boolean']['input']>;
  type: ENotificationType;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Placeholder = {
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PlaceholderMutation = {
  /** Add placeholder at the project level */
  add?: Maybe<ProjectPlaceholderGraphType>;
  /** Add placeholder at the project level */
  remove?: Maybe<Scalars['Boolean']['output']>;
  /** Remove placeholder at the project level */
  update?: Maybe<ProjectPlaceholderGraphType>;
};


export type PlaceholderMutationAddArgs = {
  key: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type PlaceholderMutationRemoveArgs = {
  placeholderId: Scalars['Int']['input'];
};


export type PlaceholderMutationUpdateArgs = {
  id: Scalars['Int']['input'];
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type PlaceholderQuery = {
  /** List placeholders for project */
  list?: Maybe<ProjectPlaceholderConnection>;
  listForUsage?: Maybe<StringConnection>;
};


export type PlaceholderQueryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['String']['input'];
};


export type PlaceholderQueryListForUsageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  usage?: InputMaybe<EEmailUsage>;
};

export type PlaceholdersInputType = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Project = {
  /** Contains all the mutations about the Project Configurations */
  configurations?: Maybe<PushNotificationConfigurationMutation>;
  /** Define the contact email for the project */
  defineContactEmail?: Maybe<Scalars['Boolean']['output']>;
  enable?: Maybe<ProjectGraphType>;
  /** Set a project as active */
  setActive?: Maybe<Scalars['Boolean']['output']>;
  /** Toggle a feature for the project */
  toggleFeature?: Maybe<Scalars['Boolean']['output']>;
  /** Update a project */
  update?: Maybe<ProjectGraphType>;
  verifyEmail?: Maybe<Scalars['Boolean']['output']>;
};


export type ProjectDefineContactEmailArgs = {
  email: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type ProjectEnableArgs = {
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type ProjectSetActiveArgs = {
  projectId: Scalars['String']['input'];
};


export type ProjectToggleFeatureArgs = {
  feature: EProjectFeature;
  projectId: Scalars['String']['input'];
  toggle: Scalars['Boolean']['input'];
};


export type ProjectUpdateArgs = {
  displayedName?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectVerifyEmailArgs = {
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  replyTo: Scalars['String']['input'];
};

export type ProjectConfiguration = {
  id: Scalars['Int']['output'];
  projectId: Scalars['String']['output'];
  pushNotificationConfiguration?: Maybe<PushNotificationConfigurationInterface>;
};

export type ProjectGraphType = {
  active: Scalars['Boolean']['output'];
  configuration?: Maybe<ProjectConfiguration>;
  displayedName: Scalars['String']['output'];
  features?: Maybe<Array<Maybe<DictionaryGraphType>>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notificationsGroups?: Maybe<Array<Maybe<NotificationGroupGraphType>>>;
  serverKey: Scalars['String']['output'];
  templates?: Maybe<Array<Maybe<TemplateGraphType>>>;
};


export type ProjectGraphTypeNotificationsGroupsArgs = {
  notificationGroupId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection from an object to a list of objects of type `ProjectPlaceholder`. */
export type ProjectPlaceholderConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ProjectPlaceholderEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<ProjectPlaceholderGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ProjectPlaceholder`. */
export type ProjectPlaceholderEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProjectPlaceholderGraphType>;
};

export type ProjectPlaceholderGraphType = {
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProjectQuery = {
  getProject?: Maybe<ProjectGraphType>;
  /** Get project settings */
  getSettings?: Maybe<Array<Maybe<ProjectSettingsGraphType>>>;
  /** @deprecated Use the methods in the template query */
  getTemplate?: Maybe<TemplateGraphType>;
  /** @deprecated Use the methods in the template query */
  getTemplates?: Maybe<Array<Maybe<TemplateGraphType>>>;
  /** Check if a project has a specific feature */
  hasFeature?: Maybe<Scalars['Boolean']['output']>;
  /** List verified emails for the project */
  listVerifiedEmails: Array<Maybe<VerifiedEmailGraphType>>;
  /** @deprecated Use the methods in the template query */
  search?: Maybe<TemplateConnection>;
};


export type ProjectQueryGetProjectArgs = {
  projectId: Scalars['String']['input'];
};


export type ProjectQueryGetSettingsArgs = {
  projectId: Scalars['String']['input'];
};


export type ProjectQueryGetTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type ProjectQueryGetTemplatesArgs = {
  projectId: Scalars['String']['input'];
};


export type ProjectQueryHasFeatureArgs = {
  feature: EProjectFeature;
  projectId: Scalars['String']['input'];
};


export type ProjectQueryListVerifiedEmailsArgs = {
  projectId: Scalars['String']['input'];
};


export type ProjectQuerySearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['String']['input'];
};

export type ProjectSettingInputType = {
  enabled: Scalars['Boolean']['input'];
  setting: EProjectSetting;
  value: Scalars['String']['input'];
};

export type ProjectSettingsGraphType = {
  hasAnnouncements?: Maybe<Scalars['String']['output']>;
};

export type ProjectSettingsMutation = {
  /** Create and update project settings. */
  createOrUpdateProjectSettings?: Maybe<Scalars['Boolean']['output']>;
};


export type ProjectSettingsMutationCreateOrUpdateProjectSettingsArgs = {
  projectSettings: CreateUpdateProjectSettingsInputType;
};

export type PushNotificationConfigurationExpoInputType = {
  default?: InputMaybe<Scalars['String']['input']>;
};

export type PushNotificationConfigurationFirebaseGraphType = PushNotificationConfigurationInterface & {
  id: Scalars['Int']['output'];
  projectConfigurationId: Scalars['Int']['output'];
  senderId: Scalars['String']['output'];
  serverKey: Scalars['String']['output'];
};

export type PushNotificationConfigurationFirebaseInputType = {
  senderId: Scalars['String']['input'];
  serverKey: Scalars['String']['input'];
};

export type PushNotificationConfigurationInterface = {
  id: Scalars['Int']['output'];
  projectConfigurationId: Scalars['Int']['output'];
};

export type PushNotificationConfigurationMutation = {
  /** Create a push notification configuration */
  createPushNotificationConfiguration?: Maybe<PushNotificationConfigurationInterface>;
  /**
   * Create a project configuration
   * @deprecated Not usable
   */
  instanceConfiguration?: Maybe<ProjectConfiguration>;
  /** Update a push notification configuration */
  updatePushNotificationConfiguration?: Maybe<PushNotificationConfigurationInterface>;
};


export type PushNotificationConfigurationMutationCreatePushNotificationConfigurationArgs = {
  projectId: Scalars['String']['input'];
  pushNotificationConfigurationExpo?: InputMaybe<PushNotificationConfigurationExpoInputType>;
  pushNotificationConfigurationFirebase?: InputMaybe<PushNotificationConfigurationFirebaseInputType>;
};


export type PushNotificationConfigurationMutationInstanceConfigurationArgs = {
  projectId: Scalars['String']['input'];
};


export type PushNotificationConfigurationMutationUpdatePushNotificationConfigurationArgs = {
  projectId: Scalars['String']['input'];
  pushNotificationConfigurationExpo?: InputMaybe<PushNotificationConfigurationExpoInputType>;
  pushNotificationConfigurationFirebase?: InputMaybe<PushNotificationConfigurationFirebaseInputType>;
};

export type PushNotificationConfigurationQuery = {
  pushNotificationConfigurationFirebase?: Maybe<PushNotificationConfigurationFirebaseGraphType>;
};


export type PushNotificationConfigurationQueryPushNotificationConfigurationFirebaseArgs = {
  id: Scalars['Int']['input'];
};

export type Queries = {
  /** Contains all queries about announce */
  announce?: Maybe<AnnounceQuery>;
  /** Contains all the queries about notifications */
  notification?: Maybe<NotificationQueries>;
  /** Contains all queries about announce */
  placeholder?: Maybe<PlaceholderQuery>;
  /** Contains all the queries about projects */
  project?: Maybe<ProjectQuery>;
  /** Contains all the queries about push notification configurations */
  pushNotificationConfigurations?: Maybe<PushNotificationConfigurationQuery>;
  /** Contains all the queries about reports */
  report?: Maybe<ReportQueries>;
  /** Contains all queries about templates */
  template?: Maybe<TemplateQuery>;
  /** Contains all queries about template layouts */
  templateLayout?: Maybe<TemplateLayoutQuery>;
  /** Contains all queries about users */
  user?: Maybe<UserQuery>;
};

export type ReportQueries = {
  /** Export the notification from a specific project */
  exportNotifications?: Maybe<AssetGraphType>;
};


export type ReportQueriesExportNotificationsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  fileType?: InputMaybe<FileType>;
  ianaTimeZone: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

/** A connection from an object to a list of objects of type `String`. */
export type StringConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<StringEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `String`. */
export type StringEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Scalars['String']['output']>;
};

/** A connection from an object to a list of objects of type `Template`. */
export type TemplateConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<TemplateEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<TemplateGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Template`. */
export type TemplateEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TemplateGraphType>;
};

export type TemplateGraphType = {
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  layout?: Maybe<TemplateLayoutGraphType>;
  name: Scalars['String']['output'];
  smsUsage?: Maybe<Array<Maybe<ESmsUsage>>>;
  subject?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ETemplateType>;
  usage?: Maybe<Array<Maybe<EEmailUsage>>>;
};

export type TemplateInput = {
  content: Scalars['String']['input'];
  messageType: EMessageType;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateLayoutId?: InputMaybe<Scalars['Int']['input']>;
  type: ETemplateType;
};

export type TemplateLayoutBodyGraphType = {
  /** Layout code */
  code: Scalars['String']['output'];
  /** Is manually edited */
  isManuallyEdited: Scalars['Boolean']['output'];
  /** Values */
  values?: Maybe<Array<Maybe<DictionaryTemplateLayoutKeyGraphType>>>;
};

export type TemplateLayoutBodyInputGraphType = {
  /** Layout code */
  code: Scalars['String']['input'];
  /** Is manually edited */
  isManuallyEdited: Scalars['Boolean']['input'];
  /** Values */
  values?: InputMaybe<Array<InputMaybe<DictionaryTemplateLayoutKeyInputType>>>;
};

/** A connection from an object to a list of objects of type `TemplateLayout`. */
export type TemplateLayoutConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<TemplateLayoutEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<TemplateLayoutGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `TemplateLayout`. */
export type TemplateLayoutEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TemplateLayoutGraphType>;
};

export type TemplateLayoutFooterGraphType = {
  /** Layout code */
  code: Scalars['String']['output'];
  /** Is manually edited */
  isManuallyEdited: Scalars['Boolean']['output'];
  /** Values */
  values?: Maybe<Array<Maybe<DictionaryTemplateLayoutKeyGraphType>>>;
};

export type TemplateLayoutFooterInputGraphType = {
  /** Layout code */
  code: Scalars['String']['input'];
  /** Is manually edited */
  isManuallyEdited: Scalars['Boolean']['input'];
  /** Values */
  values?: InputMaybe<Array<InputMaybe<DictionaryTemplateLayoutKeyInputType>>>;
};

export type TemplateLayoutGraphType = {
  /** Body */
  body?: Maybe<TemplateLayoutBodyGraphType>;
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Footer */
  footer?: Maybe<TemplateLayoutFooterGraphType>;
  /** Header */
  header?: Maybe<TemplateLayoutHeaderGraphType>;
  /** Id */
  id: Scalars['Int']['output'];
  /** Title */
  title: Scalars['String']['output'];
};

export type TemplateLayoutHeaderGraphType = {
  /** Layout code */
  code: Scalars['String']['output'];
  /** Is manually edited */
  isManuallyEdited: Scalars['Boolean']['output'];
  /** Values */
  values?: Maybe<Array<Maybe<DictionaryTemplateLayoutKeyGraphType>>>;
};

export type TemplateLayoutHeaderInputGraphType = {
  /** Layout code */
  code: Scalars['String']['input'];
  /** Is manually edited */
  isManuallyEdited: Scalars['Boolean']['input'];
  /** Values */
  values?: InputMaybe<Array<InputMaybe<DictionaryTemplateLayoutKeyInputType>>>;
};

export type TemplateLayoutInputGraphType = {
  /** Body */
  body?: InputMaybe<TemplateLayoutBodyInputGraphType>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Footer */
  footer?: InputMaybe<TemplateLayoutFooterInputGraphType>;
  /** Header */
  header?: InputMaybe<TemplateLayoutHeaderInputGraphType>;
  /** Title */
  title: Scalars['String']['input'];
};

export type TemplateLayoutMutation = {
  /** Add a template layout */
  add?: Maybe<TemplateLayoutGraphType>;
  /** Delete a template layout */
  delete?: Maybe<Scalars['Boolean']['output']>;
  /** Update a template layout */
  update?: Maybe<TemplateLayoutGraphType>;
};


export type TemplateLayoutMutationAddArgs = {
  projectId: Scalars['String']['input'];
  request: TemplateLayoutInputGraphType;
};


export type TemplateLayoutMutationDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type TemplateLayoutMutationUpdateArgs = {
  id: Scalars['Int']['input'];
  request: TemplateLayoutInputGraphType;
};

export type TemplateLayoutQuery = {
  get?: Maybe<TemplateLayoutGraphType>;
  list?: Maybe<TemplateLayoutConnection>;
};


export type TemplateLayoutQueryGetArgs = {
  id: Scalars['Int']['input'];
};


export type TemplateLayoutQueryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['String']['input'];
};

export type TemplateMutation = {
  /** Set an usage to an existing template */
  addOrUpdateSmsTemplateUsage?: Maybe<Scalars['Boolean']['output']>;
  /** Set an usage to an existing template */
  addOrUpdateTemplateUsage?: Maybe<Scalars['Boolean']['output']>;
  /** Add a template to the selected project */
  addTemplate?: Maybe<TemplateGraphType>;
  bulkDelete?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateLayouts?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a template */
  delete?: Maybe<Scalars['Boolean']['output']>;
  /** Edit an existing template */
  editTemplate?: Maybe<Scalars['Boolean']['output']>;
  removeUsage?: Maybe<Scalars['Boolean']['output']>;
};


export type TemplateMutationAddOrUpdateSmsTemplateUsageArgs = {
  request: AddOrUpdateTemplateUsageSmsInputType;
};


export type TemplateMutationAddOrUpdateTemplateUsageArgs = {
  request: AddOrUpdateTemplateUsageInputType;
};


export type TemplateMutationAddTemplateArgs = {
  emailUsage?: InputMaybe<EEmailUsage>;
  smsUsage?: InputMaybe<ESmsUsage>;
  template: TemplateInput;
};


export type TemplateMutationBulkDeleteArgs = {
  templateIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type TemplateMutationBulkUpdateLayoutsArgs = {
  templateIds: Array<InputMaybe<Scalars['Int']['input']>>;
  templateLayoutId: Scalars['Int']['input'];
};


export type TemplateMutationDeleteArgs = {
  templateId: Scalars['Int']['input'];
};


export type TemplateMutationEditTemplateArgs = {
  emailUsage?: InputMaybe<EEmailUsage>;
  smsUsage?: InputMaybe<ESmsUsage>;
  template?: InputMaybe<TemplateInput>;
  templateId: Scalars['Int']['input'];
};


export type TemplateMutationRemoveUsageArgs = {
  templateId: Scalars['Int']['input'];
  usage?: InputMaybe<EEmailUsage>;
};

export type TemplateQuery = {
  get?: Maybe<TemplateGraphType>;
  list?: Maybe<TemplateConnection>;
};


export type TemplateQueryGetArgs = {
  id: Scalars['Int']['input'];
};


export type TemplateQueryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['String']['input'];
};

export type UserGraphType = {
  email: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  settings?: Maybe<Array<Maybe<EUserNotificationPreference>>>;
};

export type UserMutation = {
  /** Add device */
  addDevice?: Maybe<Scalars['Boolean']['output']>;
  /** Enable account of the user */
  enableAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Set black list */
  setBlacklist?: Maybe<Scalars['Boolean']['output']>;
  /** Unsubscribe to certain type of notification */
  unsubscribe?: Maybe<Scalars['Boolean']['output']>;
  /** Update settings */
  updateSettings?: Maybe<UserGraphType>;
};


export type UserMutationAddDeviceArgs = {
  token: Scalars['String']['input'];
};


export type UserMutationEnableAccountArgs = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type UserMutationSetBlacklistArgs = {
  notificationGuid: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  receiver: Scalars['String']['input'];
};


export type UserMutationUnsubscribeArgs = {
  messageTypes: Array<InputMaybe<EMessageType>>;
  notificationType: ENotificationType;
};


export type UserMutationUpdateSettingsArgs = {
  inputType: Array<InputMaybe<EUserNotificationPreference>>;
};

export type UserQuery = {
  /** get user info */
  getUser?: Maybe<UserGraphType>;
};

export type VerifiedEmailGraphType = {
  /** Display name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Is verified */
  isVerified: Scalars['Boolean']['output'];
  /** Reply to */
  replyTo?: Maybe<Scalars['String']['output']>;
};

export type SendMailsMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  receiver: Scalars['String']['input'];
  placeholders: Array<InputMaybe<PlaceholdersInputType>> | InputMaybe<PlaceholdersInputType>;
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInputType>> | InputMaybe<AttachmentInputType>>;
  subject: Scalars['String']['input'];
  templateId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SendMailsMutation = { notification?: { sendMails?: { id: number } } };

export type UpdateHowlerUserSettingsMutationVariables = Exact<{
  inputType: Array<InputMaybe<EUserNotificationPreference>> | InputMaybe<EUserNotificationPreference>;
}>;


export type UpdateHowlerUserSettingsMutation = { user?: { updateSettings?: { settings?: Array<EUserNotificationPreference> } } };

export type GetHowlerUserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHowlerUserSettingsQuery = { user?: { getUser?: { email: string, settings?: Array<EUserNotificationPreference> } } };


export const SendMailsDocument = gql`
    mutation sendMails($projectId: String!, $receiver: String!, $placeholders: [PlaceholdersInputType]!, $attachments: [AttachmentInputType], $subject: String!, $templateId: Int!, $userId: Int) {
  notification {
    sendMails(
      notificationGroup: {notifications: {receiver: $receiver, userId: $userId, placeholders: $placeholders, attachments: $attachments}, subject: $subject, templateId: $templateId, projectId: $projectId}
    ) {
      id
    }
  }
}
    `;
export type SendMailsMutationFn = Apollo.MutationFunction<SendMailsMutation, SendMailsMutationVariables>;

/**
 * __useSendMailsMutation__
 *
 * To run a mutation, you first call `useSendMailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMailsMutation, { data, loading, error }] = useSendMailsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      receiver: // value for 'receiver'
 *      placeholders: // value for 'placeholders'
 *      attachments: // value for 'attachments'
 *      subject: // value for 'subject'
 *      templateId: // value for 'templateId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendMailsMutation(baseOptions?: Apollo.MutationHookOptions<SendMailsMutation, SendMailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMailsMutation, SendMailsMutationVariables>(SendMailsDocument, options);
      }
export type SendMailsMutationHookResult = ReturnType<typeof useSendMailsMutation>;
export type SendMailsMutationResult = Apollo.MutationResult<SendMailsMutation>;
export type SendMailsMutationOptions = Apollo.BaseMutationOptions<SendMailsMutation, SendMailsMutationVariables>;
export const UpdateHowlerUserSettingsDocument = gql`
    mutation updateHowlerUserSettings($inputType: [EUserNotificationPreference]!) {
  user {
    updateSettings(inputType: $inputType) {
      settings
    }
  }
}
    `;
export type UpdateHowlerUserSettingsMutationFn = Apollo.MutationFunction<UpdateHowlerUserSettingsMutation, UpdateHowlerUserSettingsMutationVariables>;

/**
 * __useUpdateHowlerUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateHowlerUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHowlerUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHowlerUserSettingsMutation, { data, loading, error }] = useUpdateHowlerUserSettingsMutation({
 *   variables: {
 *      inputType: // value for 'inputType'
 *   },
 * });
 */
export function useUpdateHowlerUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHowlerUserSettingsMutation, UpdateHowlerUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHowlerUserSettingsMutation, UpdateHowlerUserSettingsMutationVariables>(UpdateHowlerUserSettingsDocument, options);
      }
export type UpdateHowlerUserSettingsMutationHookResult = ReturnType<typeof useUpdateHowlerUserSettingsMutation>;
export type UpdateHowlerUserSettingsMutationResult = Apollo.MutationResult<UpdateHowlerUserSettingsMutation>;
export type UpdateHowlerUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateHowlerUserSettingsMutation, UpdateHowlerUserSettingsMutationVariables>;
export const GetHowlerUserSettingsDocument = gql`
    query GetHowlerUserSettings {
  user {
    getUser {
      email
      settings
    }
  }
}
    `;

/**
 * __useGetHowlerUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetHowlerUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHowlerUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHowlerUserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHowlerUserSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetHowlerUserSettingsQuery, GetHowlerUserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHowlerUserSettingsQuery, GetHowlerUserSettingsQueryVariables>(GetHowlerUserSettingsDocument, options);
      }
export function useGetHowlerUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHowlerUserSettingsQuery, GetHowlerUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHowlerUserSettingsQuery, GetHowlerUserSettingsQueryVariables>(GetHowlerUserSettingsDocument, options);
        }
export type GetHowlerUserSettingsQueryHookResult = ReturnType<typeof useGetHowlerUserSettingsQuery>;
export type GetHowlerUserSettingsLazyQueryHookResult = ReturnType<typeof useGetHowlerUserSettingsLazyQuery>;
export type GetHowlerUserSettingsQueryResult = Apollo.QueryResult<GetHowlerUserSettingsQuery, GetHowlerUserSettingsQueryVariables>;